import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { IPointAward } from 'components/awards/models';
import { useTokenizedString } from '../useTokenizedString';

const PREFIX = 'PseudoCurrency';

const classes = {
    title: `${PREFIX}title`,
    subtitle: `${PREFIX}subtitle`,
    description: `${PREFIX}description`
};

const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.title}`]: {
        fontSize: theme.spacing(2.5)
    },

    [`& .${classes.subtitle}`]: {
        fontSize: theme.spacing(4),
        fontWeight: theme.typography.fontWeightBold
    },

    [`& .${classes.description}`]: {
        fontSize: theme.spacing(2.5),
        fontWeight: theme.typography.fontWeightBold
    }
}));

interface IProps {
    award: IPointAward;
}

export const PseudoCurrency: React.FC<IProps> = ({ award }) => {
    const { renderTokenizedString } = useTokenizedString(award);

    return (
        <StyledBox width="100%">
            {award.visualisation.titleText && (
                <Typography display="block" className={classes.title}>
                    {award.visualisation.titleText}
                </Typography>
            )}
            {award.visualisation.subtitleText && (
                <Typography display="block" className={classes.subtitle}>
                    {renderTokenizedString(award.visualisation.subtitleText)}
                </Typography>
            )}
            {award.visualisation.subtitleTwoText && (
                <Typography display="block" className={classes.description}>
                    {renderTokenizedString(award.visualisation.subtitleTwoText)}
                </Typography>
            )}
        </StyledBox>
    );
};
